import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CURRENCY_MASK_CONFIG } from 'ng2-currency-mask';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HttpInterceptorService } from './core/services/http-interceptor.service';
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { IconModule } from './icon.module';
import { configureDayjs } from './dayjs.config';
import { customCurrencyMaskConfig } from './currency-mask.config';

registerLocaleData(localePt);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    IconModule,
    MatProgressBarModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      preventDuplicates: true,
      enableHtml: true,
      positionClass: 'toast-bottom-center'
    })
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //   enabled: true,
    //   registrationStrategy: 'registerImmediately'
    // })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    { provide: CURRENCY_MASK_CONFIG, useValue: customCurrencyMaskConfig },
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    this.unregisterServiceWorker();
    configureDayjs();
  }

  private unregisterServiceWorker() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.unregister();
          console.log('Serviceworker registro cancelado');
        }
      });
    }
  }
}
